import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { HardHat, ShieldCheck } from 'lucide-react';
import { WrapUpFlow, trainerApi } from './TrainingWrapUpModal';
import { fmtD } from './TrainingCardsParts';

// Chad's page. No login — the link HR sent him is the key, and it only opens this one session.
export default function TrainerPage() {
  const { token } = useParams();
  const api = useMemo(() => trainerApi(token), [token]);
  const [prep, setPrep] = useState(null);
  const [err, setErr] = useState(null);
  const s = prep?.session;
  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="trainer-page">
      <div className="bg-slate-900 border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center font-black">365</div>
          <div className="min-w-0">
            <p className="font-bold leading-tight flex items-center gap-2"><HardHat className="w-4 h-4 text-amber-300" /> Training wrap-up</p>
            <p className="text-xs text-slate-400 truncate" data-testid="trainer-session-line">
              {s ? `${s.provider_name} · ${fmtD(s.start_date)}${s.end_date !== s.start_date ? ` – ${fmtD(s.end_date)}` : ''}${s.location ? ` · ${s.location}` : ''}` : '365 Industrial Services'}
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-2 sm:p-4">
        {err ? (
          <div className="rounded-2xl border border-rose-500/40 bg-rose-500/10 p-6 text-center" data-testid="trainer-error">
            <p className="font-semibold text-rose-100">{err}</p>
            <p className="text-sm text-slate-300 mt-2">Give 365 a shout and they'll send a new link.</p>
          </div>
        ) : (
          <div className="bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl">
            {prep && (
              <div className="px-4 pt-4 text-sm text-slate-300 flex items-start gap-2" data-testid="trainer-intro">
                <ShieldCheck className="w-4 h-4 text-emerald-300 mt-0.5 shrink-0" />
                <p>Hi {prep.trainer_name} — tick who was there and what you covered, sign, and hit Generate. Each person's cards get filed straight into their 365 safety file and a print sheet is ready right after.</p>
              </div>
            )}
            <WrapUpFlow api={api} trainerMode onPrep={setPrep} onLoadError={(e) => setErr(e.response?.data?.detail || 'This link could not be opened.')} />
          </div>
        )}
        <p className="text-center text-[11px] text-slate-600 mt-4">365 Industrial Services · this link opens only this training session</p>
      </div>
    </div>
  );
}
